module.exports = "/lucky-balls/img/weager/ball-chosen-holder.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/ball-chosen-holder.png
// module id = 1175
// module chunks = 0